<template>
  <div>
    <NavMenu />
    <div class="page-content">
      <div v-if="busy" class="busy-container"><BusySpinner /></div>
      <div v-else>
        <DownloadTracker />
      </div>
    </div>
  </div>
</template>

<script>

import NavMenu from '@/components/NavMenu.vue'
import BusySpinner from '@/components/BusySpinner.vue'
import DownloadTracker from '@/components/DownloadTracker.vue'

export default {
  name: 'Analytics',
  components: { NavMenu, BusySpinner, DownloadTracker },
  data: () => ({
    busy: false
  })
}
</script>

<style lang="scss" scoped>
.page-content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 30px;
  width: 100%;
}
</style>
